import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "./components/Layout";

// Pages
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ServicesPage from "./pages/Services";
import TestimonialsPage from "./pages/Testimonials";
import DataRecoveryPage from "./pages/DataRecovery";
import ConnectPage from "./pages/Connect";

// SEO configuration for each page
const seoConfig = {
  '/': {
    title: 'NPM Computer Sales & Service | Business IT Solutions in Las Vegas',
    description: 'NPM provides business technology sales, deployment, managed IT, and cybersecurity support for organizations in Las Vegas and Henderson. Call (702) 769-5422.',
    ogTitle: 'NPM Computer Sales & Service - Business IT Solutions',
    ogDescription: 'Your business depends on computer infrastructure. We sell, secure, and manage business technology from devices and networks to Microsoft 365, cybersecurity, and user support.'
  },
  '/about': {
    title: 'About NPM | Business IT Services in Las Vegas & Henderson',
    description: 'Learn about NPM Computer Sales & Service - providing stable systems, predictable support, and security-first IT standards for Las Vegas and Henderson businesses.',
    ogTitle: 'About NPM Computer Sales & Service',
    ogDescription: 'NPM provides business technology sales, deployment, managed IT, and cybersecurity support. The focus is stable systems, predictable support, and security-first standards.'
  },
  '/services': {
    title: 'IT Services | Managed IT, Security, Microsoft 365 | NPM',
    description: 'One partner for sales, deployment, support, and security. NPM covers IT operations plus projects like refreshes, migrations, and network upgrades.',
    ogTitle: 'IT Services - NPM Computer Sales & Service',
    ogDescription: 'Managed IT, cybersecurity, Microsoft 365 administration, network support, voice systems, and AI automation services for businesses.'
  },
  '/testimonials': {
    title: 'Client Testimonials | NPM Computer Sales & Service',
    description: 'Clients rely on NPM for responsive support, clear communication, and consistent results across devices, networks, and security.',
    ogTitle: 'Client Testimonials - NPM Computer Sales & Service',
    ogDescription: 'See what our clients say about NPM IT services - responsive support, clear communication, and consistent results.'
  },
  '/data-recovery': {
    title: 'Data Recovery Services | NPM Computer Sales & Service',
    description: 'Data loss disrupts work and adds risk. NPM coordinates secure data recovery including intake guidance, case coordination, and secure return of recovered data.',
    ogTitle: 'Data Recovery Services - NPM Computer Sales & Service',
    ogDescription: 'Professional data recovery coordination for workstations, servers, and external drives. Call (702) 769-5422 right away if data access is lost.'
  },
  '/connect': {
    title: 'Contact Us | NPM Computer Sales & Service | (702) 769-5422',
    description: 'Contact NPM for support, procurement, managed IT, security improvements, Microsoft 365 administration, network upgrades, voice systems, or automation projects.',
    ogTitle: 'Connect With NPM Computer Sales & Service',
    ogDescription: 'Reach out to NPM for IT support and services. Located in Henderson, NV. Call (702) 769-5422 or email david@applevar.com.'
  }
};

// SEO Component
const SEO = () => {
  const location = useLocation();
  const seo = seoConfig[location.pathname] || seoConfig['/'];

  useEffect(() => {
    document.title = seo.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', seo.description);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', seo.ogTitle);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', seo.ogDescription);
    }
  }, [seo, location.pathname]);

  return null;
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEO />
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/data-recovery" element={<DataRecoveryPage />} />
            <Route path="/connect" element={<ConnectPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
